export default "__VITE_ASSET__neKzbv$o__"